class DeferredMediaWithAudioComponent extends HTMLElement {
  constructor() {
    super();
    this.deferredMediaPlayButton = this.querySelector('[ref="deferredMediaPlayButton"]');
    this.unmuteButton = this.querySelector('[ref="unmuteButton"]');
    this.video = this.querySelector('video');
  }

  connectedCallback() {
    if (this.deferredMediaPlayButton) {
      this.deferredMediaPlayButton.addEventListener('click', this.showDeferredMedia.bind(this));
    }

    if (this.unmuteButton) {
      this.unmuteButton.addEventListener('click', this.toggleAudio.bind(this));
    }

    // Check if autoplay is enabled
    if (this.hasAttribute('autoplay')) {
      this.showDeferredMedia();
    }
  }

  showDeferredMedia() {
    // Hide the play button and show unmute button
    if (this.deferredMediaPlayButton) {
      this.deferredMediaPlayButton.style.display = 'none';
    }

    if (this.unmuteButton) {
      this.unmuteButton.classList.remove('hidden');
      this.unmuteButton.classList.add('muted');
    }

    // Set up video element for audio control
    this.setupVideoAudio();
  }

  toggleAudio() {
    const video = this.querySelector('video');

    if (video && this.unmuteButton) {
      if (video.muted) {
        video.muted = false;
        this.unmuteButton.classList.remove('muted');
        this.unmuteButton.classList.add('unmuted');
        this.unmuteButton.classList.add('hidden');
      } else {
        video.muted = true;
        this.unmuteButton.classList.remove('unmuted');
        this.unmuteButton.classList.add('muted');
        this.unmuteButton.classList.remove('hidden');
      }
    }
  }

  setupVideoAudio() {
    const video = this.video || this.querySelector('video');

    if (video && this.unmuteButton) {
      // Initially mute the video for autoplay compliance
      video.muted = true;
      
      // Show unmute button initially
      this.unmuteButton.classList.remove('hidden');
      this.unmuteButton.classList.add('muted');

      // Add click event to video for mute/unmute toggle
      video.addEventListener('click', () => {
        this.toggleAudio();
      });

      // Handle Safari autoplay restrictions
      video.addEventListener('loadstart', () => {
        // Ensure video is muted for autoplay
        video.muted = true;
      });

      video.addEventListener('canplay', () => {
        // Try to play the video (Safari might block this)
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Autoplay was prevented, show play button or keep muted
            console.log('Autoplay prevented by browser');
          });
        }
      });

      // Hide unmute button when video is unmuted
      video.addEventListener('volumechange', () => {
        if (!video.muted) {
          this.unmuteButton.classList.add('hidden');
          this.unmuteButton.classList.remove('muted');
          this.unmuteButton.classList.add('unmuted');
        } else {
          this.unmuteButton.classList.remove('hidden');
          this.unmuteButton.classList.remove('unmuted');
          this.unmuteButton.classList.add('muted');
        }
      });
    }
  }
}

if (!customElements.get('deferred-media-with-audio')) {
  customElements.define('deferred-media-with-audio', DeferredMediaWithAudioComponent);
} 